import { useRef } from 'react';
import { useInView } from './useInView';

export interface AuroraBackgroundProps {
  /** `dark` glows over ink/photos; `light` tints pale surfaces. */
  variant?: 'light' | 'dark';
  className?: string;
}

/**
 * Absolutely positioned luminous mesh-gradient blobs drifting on 8–12 s loops (static under reduced motion).
 * The drift pauses while the aurora is off screen, so it costs nothing on frames where it can't be seen.
 */
export default function AuroraBackground({ variant = 'dark', className = '' }: AuroraBackgroundProps) {
  const ref = useRef<HTMLDivElement>(null);
  const onScreen = useInView(ref, { threshold: 0, rootMargin: '0px', once: false });

  return (
    <div ref={ref} className={`aurora aurora--${variant} ${onScreen ? '' : 'is-idle'} ${className}`} aria-hidden="true">
      <span className="aurora-blob" />
      <span className="aurora-blob" />
      <span className="aurora-blob" />
      <span className="aurora-blob" />
    </div>
  );
}
